import { Violation, ViolationSeverity } from '@skylab-shared/core';

export class ItemQuantityHigherThanReceiptItemQuantityError extends Violation {
    public constructor() {
        super(ViolationSeverity.Error, 'business.document.sale.validation.items.quantity.higher-than-receipt-quantity');
    }
}
